var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c('div',[_c('div',{staticClass:"section_inner"},[_c('AgentHeader',{attrs:{"title":_vm.pageTitle,"text":_vm.pageSubTitle}}),_vm._v(" "),_c('SmartalertsSettings',{attrs:{"agent-code":_vm.agentCode}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }